document.addEventListener('DOMContentLoaded', () => {
  const sizingGuideData = {
    dresses_inches: {
      header: ['SIZE', 'SIZE US', 'CHEST', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '31,5-32,5', '24,5-25,5', '35.5-36,5'],
        ['XS', '2', '33-34', '26-27', '37-38'],
        ['S', '4', '34,5-35,5', '27,5-28,5', '38,5-39,5'],
        ['M', '6', '36-37', '29-30', '40-41'],
        ['L', '8', '38-39', '31-32', '42-43'],
        ['2L', '10', '39,5-40,5', '32,5-33,5', '43,5-44,5'],
        ['3L', '12', '41-42', '34-35', '45-46']
      ]
    },

    dresses_centimeters: {
      header: ['SIZE', 'SIZE US', 'CHEST', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '80-82', '62-64', '90-92'],
        ['XS', '2', '84-86', '66-68', '94-96'],
        ['S', '4', '88-90', '70-72', '98-100'],
        ['M', '6', '92-94', '74-76', '102-104'],
        ['L', '8', '97-99', '79-81', '107-109'],
        ['2L', '10', '101-103', '83-85', '111-113'],
        ['3L', '12', '105-107', '87-89', '115-117']
      ]
    },


    jumpsuits_inches: {
      header: ['SIZE', 'SIZE US', 'CHEST', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '31,5-32,5', '24,5-25,5', '35.5-36,5'],
        ['XS', '2', '33-34', '26-27', '37-38'],
        ['S', '4', '34,5-35,5', '27,5-28,5', '38,5-39,5'],
        ['M', '6', '36-37', '29-30', '40-41'],
        ['L', '8', '38-39', '31-32', '42-43'],
        ['2L', '10', '39,5-40,5', '32,5-33,5', '43,5-44,5'],
        ['3L', '12', '41-42', '34-35', '45-46']
      ]
    },

    jumpsuits_centimeters: {
      header: ['SIZE', 'SIZE US', 'CHEST', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '80-82', '62-64', '90-92'],
        ['XS', '2', '84-86', '66-68', '94-96'],
        ['S', '4', '88-90', '70-72', '98-100'],
        ['M', '6', '92-94', '74-76', '102-104'],
        ['L', '8', '97-99', '79-81', '107-109'],
        ['2L', '10', '101-103', '83-85', '111-113'],
        ['3L', '12', '105-107', '87-89', '115-117']
      ]
    },

    shirts_and_tops_inches: {
      header: ['SIZE', 'SIZE US', 'CHEST', 'WAIST'],
      body: [
        ['XXS', '0', '31,5-32,5', '24,5-25,5'],
        ['XS', '2', '33-34', '26-27'],
        ['S', '4', '34,5-35,5', '27,5-28,5'],
        ['M', '6', '36-37', '29-30'],
        ['L', '8', '38-39', '31-32'],
        ['2L', '10', '39,5-40,5', '32,5-33,5'],
        ['3L', '12', '41-42', '34-35']
      ]
    },

    shirts_and_tops_centimeters: {
      header: ['SIZE', 'SIZE US', 'CHEST', 'WAIST'],
      body: [
        ['XXS', '0', '80- 82', '62- 64'],
        ['XS', '2', '84-86', '66-68'],
        ['S', '4', '88-90', '70-72'],
        ['M', '6', '92-94', '74-76'],
        ['L', '8', '97-99', '79-81'],
        ['2L', '10', '101-103', '83-85'],
        ['3L', '12', '105-107', '87-89']
      ]
    },

    pants_inches: {
      header: ['SIZE', 'SIZE US', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '24,5-25,5', '35.5-36,5'],
        ['XS', '2', '26-27', '37-38'],
        ['S', '4', '27,5-28,5', '38,5-39,5'],
        ['M', '6', '29-30', '40-41'],
        ['L', '8', '31-32', '42-43'],
        ['2L', '10', '32,5-33,5', '43,5- 44,5'],
        ['3L', '12', '34-35', '45-46']
      ]
    },

    shirts_centimeters: {
      header: ['SIZE', 'SIZE US', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '62- 64', '90-92'],
        ['XS', '2', '66-68', '94-96'],
        ['S', '4', '70-72', '98-100'],
        ['M', '6', '74-76', '102-104'],
        ['L', '8', '79-81', '107-109'],
        ['2L', '10', '83-85', '111-113'],
        ['3L', '12', '87-89', '115-117']
      ]
    },

    bottoms_inches: {
      header: ['SIZE', 'SIZE US', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '24,5-25,5', '35.5-36,5'],
        ['XS', '2', '26-27', '37-38'],
        ['S', '4', '27,5-28,5', '38,5-39,5'],
        ['M', '6', '29-30', '40-41'],
        ['L', '8', '31-32', '42-43'],
        ['2L', '10', '32,5-33,5', '43,5- 44,5'],
        ['3L', '12', '34-35', '45-46']
      ]
    },

    bottoms_centimeters: {
      header: ['SIZE', 'SIZE US', 'WAIST', 'LOW HIP'],
      body: [
        ['XXS', '0', '62- 64', '90-92'],
        ['XS', '2', '66-68', '94-96'],
        ['S', '4', '70-72', '98-100'],
        ['M', '6', '74-76', '102-104'],
        ['L', '8', '79-81', '107-109'],
        ['2L', '10', '83-85', '111-113'],
        ['3L', '12', '87-89', '115-117']
      ]
    },

    shoes: {
      header: ['SIZE ST', 'US', 'EURO', 'UK'],
      body: [
        ['36', '6', '36', '3.5'],
        ['37', '7', '37', '4.5'],
        ['38', '8', '38', '5.5'],
        ['39', '9', '39', '6.5'],
        ['40', '10', '40', '7.5'],
        ['41', '11', '41', '8.5']
      ]
    }
  };

  const closeButton = document.querySelector('.sizing-guide-modal__close');
  const openButton = document.querySelector('.radios-label__button');
  const modal = document.querySelector('.sizing-guide-modal');

  if (openButton && modal) {
    openButton.addEventListener('click', () => {
      modal.classList.toggle('is-open');
    });
  }

  if (closeButton && modal) {
    closeButton.addEventListener('click', () => {
      modal.classList.remove('is-open');
    });
  }

  const controls = document.querySelector('.sizing-guide-modal__controls');
  if (!controls) return;

  const table = document.querySelector('.sizing-guide-table');
  if (!table) return;

  const rawCategory = controls.dataset.category || '';
  const category = rawCategory
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/&/g, 'and');

  const hasVariants =
    !!sizingGuideData[`${category}_inches`] ||
    !!sizingGuideData[`${category}_centimeters`];

  if (!hasVariants) {
    controls.style.display = 'none';
  }

  const renderTable = (variant) => {
    const key = hasVariants ? `${category}_${variant}` : category;
    const data = sizingGuideData[key];
    if (!data) return;

    table.querySelector('thead').innerHTML = '';
    table.querySelector('tbody').innerHTML = '';

    const theadRow = document.createElement('tr');
    data.header.forEach((cell) => {
      const th = document.createElement('th');
      th.textContent = cell;
      theadRow.appendChild(th);
    });
    table.querySelector('thead').appendChild(theadRow);

    data.body.forEach((row) => {
      const tr = document.createElement('tr');
      row.forEach((cell) => {
        const td = document.createElement('td');
        td.textContent = cell;
        tr.appendChild(td);
      });
      table.querySelector('tbody').appendChild(tr);
    });
  };

  if (hasVariants) {
    const initialVariant = document.querySelector('.sizing-guide-modal__input:checked');
    renderTable(initialVariant ? initialVariant.value : 'inches');
  } else {
    renderTable();
  }

  const radios = controls.querySelectorAll('.sizing-guide-modal__input');
  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        renderTable(radio.value);
      }
    });
  });

  const sizeRadios = document.querySelectorAll(
    'fieldset[name="Size"] input[type="radio"], fieldset input[name="Size"]'
  );
  const sizeValue = document.querySelector('.radios-label__value');

  if (sizeRadios.length && sizeValue) {
    sizeRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const selected = document.querySelector('input[name="Size"]:checked');
        if (selected) {
          sizeValue.textContent = selected.value;
        }
      });
    });
  }
});
